import { render, staticRenderFns } from "./u-loader.html?vue&type=template&id=4d3dde43&scoped=true&"
import script from "./u-loader.ts?vue&type=script&lang=ts&"
export * from "./u-loader.ts?vue&type=script&lang=ts&"
import style0 from "./u-loader.scss?vue&type=style&index=0&id=4d3dde43&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3dde43",
  null
  
)

export default component.exports